"use strict"

$(document).ready(function () {
    var noteId = defaultReleaseNoteId;

    //defaultReleaseNoteId comes in as an empty string instead of null
    if (defaultReleaseNoteId.length != 0) {
        getNote(noteId);
        $("#NotesList li:first-child").addClass('selected');
    }
    else {
        $("#Edit").attr('disabled', true);
    }

    $("#NotesList").children().click(function() {
        noteId = $(this).data('id');
        $("#NotesList li").removeClass('selected');
        $(this).addClass('selected'); 
        getNote(noteId);
    });

    $("#Add").click(function () {
        window.location.href = addNoteUrl;
    });

    $("#Edit").click(function () {
        if (noteId.length != 0) {
            window.location.href = editNoteUrl.replace("THE_ID", noteId);
        }
    });

    function getNote(id) {
        $.ajax({
            url: viewNoteUrl,
            type: "GET",
            data: { id: id },
            dataType: "html",
            success: (result) => {
                $("#Note").html(result);
            }
        });
    }
});